import React, { useMemo } from 'react';
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getExcursion, getAvailability } from '../api/api';
import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/de';
import Recap from '../components/Recap';
import { strings } from '../localization/strings';

function RecapPage() {
  const location = useLocation();
  const navigate = useNavigate();

  function useQuery() {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();
  const excursionId = query.get('tourid');
  const language = query.get('lang') ?? 'it';
  let date = query.get('dateFormat');
  //date = moment(date, 'YYYY-MM-DD');
  moment.locale(language);
  const translation = strings[language] ?? strings.it;
  
  const uiDate = moment(date).format('DD MMM YYYY');
  let adult = query.get('tour-adult') ?? 0;
  let child = query.get('tour-children') ?? 0;
  let baby = query.get('tour-infant') ?? 0;
  if (adult === '') { adult = 0; }
  if (child === '') { child = 0; }
  if (baby === '') { baby = 0; }
  const passengers = parseInt(adult) + parseInt(child) + parseInt(baby);

  const state = useMemo(() => location.state || {
    inputs: {
      adult,
      child,
      baby,
      passengers,
      date,
      excursionId,
      uiDate,
      language
    }
  }, [location.state, adult, child, baby, passengers, date, excursionId, uiDate, language]);

  const [excursion, setExcursion] = useState(null);
  const [availability, setAvailability] = useState(null);

  useEffect(() => {
    async function fetchExcursion() {
      try {
        getExcursion(excursionId).then(response => {
          setExcursion(response.data);
          state.excursion = response.data;
          state.excursionName = language === 'it' ? response.data.name : response.data.nameMulti[language];
          if (response.data.homepage) {
            state.excursionUrl = response.data.baseUrl + (language === 'it' ? response.data.homepage : response.data.homepageMulti[language]);
          }
          getAvailability(excursionId, date, passengers).then(response => {
            if (!response.data || response.data.availableText === undefined || response.data.availableText === 2) {
              if (state.excursionUrl) {
                window.location.href = state.excursionUrl;
              } else {
                window.location.href = "https://booking.egadiescursioni.it/"
              }
            }
            setAvailability(response.data);
            state.availability = response.data;
          });
        }).catch(() => {
          window.location.href = "https://booking.egadiescursioni.it/"
        });
      } catch (error) {
        console.error('Error fetching the excursion data', error);
      }
    }

    if (excursionId && !excursion) {
      fetchExcursion();
    }
  }, [excursionId, date, passengers, state]);

  function nextStep() {
    navigate('/personal-data' + location.search, { state: state });
  }

  return (
    <div className="tourmaster-page-wrapper tourmaster-payment-style-1 tourmaster-template-payment" id="tourmaster-page-wrapper">
        <Header currentStep="1" tourName={state?.excursionName} language={language} tourUrl={state?.excursionUrl}/>
        <div className="tourmaster-template-wrapper" id="tourmaster-payment-template-wrapper">
          <div className="tourmaster-container">
            <div className="tourmaster-page-content tourmaster-item-pdlr clearfix">
                <h3 dangerouslySetInnerHTML={{ __html: translation.recapHeader }}></h3>
                <h5><em style={{position: 'relative'}}>{translation.recapHurry}
                <svg 
                className="nectar-scribble squiggle-underline" role="presentation" viewBox="-347 -30.1947 694 96.19"
                preserveAspectRatio="none"><path 
                d="M-335,54 C-335,54 -171,-58 -194,-3 C-217,52 -224.1199951171875,73.552001953125 -127,11 C-68,-27 -137,50 -33,42 C31.43899917602539,37.042999267578125 147.14700317382812,-29.308000564575195 335,2"
                stroke="#ff1053"
                pathLength="1"
                strokeWidth="14"
                fill="none"></path></svg>
                    </em> {translation.recapHurrySeats}</h5>
                    <div style={{margin: '40px'}}></div>
                <Recap availability={availability} excursion={excursion} excursionName={state?.excursionName} date={uiDate} adult={adult} child={child} baby={baby} nextStep={nextStep} language={language} tourUrl={state?.excursionUrl}/>
            </div>
          </div>
        </div>
    </div>
  );
}

export default RecapPage;